@import "../skeleton/skeleton.scss";

:host {
    --wcs-skeleton-border-radius: 0rem;

    span {
        border-radius: var(--wcs-skeleton-border-radius);
    }
}

:host([rounded]) {
    --wcs-skeleton-border-radius: var(--wcs-semantic-border-radius-base);
}
